var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import useCheckboxes from "../../Hooks/useCheckboxes";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import BooleanDisplay from "../../UI/BooleanDisplay/BooleanDisplay";
import { SearchButton } from "../../UI/StandardButtons/StandardButtons";
import { AlertError } from "../../UI/StandardAlerts/StandardAlerts";
import DepartmentService from "../../../Services/Department.service";
const PAGE_SIZE = 20;
const SEARCH_DEFAULT = "";
const ACTIVE_DEFAULT = 1;
const DEFAULT_SEARCH = {
    active: ACTIVE_DEFAULT,
    query: SEARCH_DEFAULT,
};
const DepartmentLookup = ({ selected: selectedDepartments, children, }) => {
    var _a;
    const [active, setActive] = React.useState(ACTIVE_DEFAULT);
    const [query, setQuery] = React.useState(SEARCH_DEFAULT);
    const [searchArgs, setSearchArgs] = React.useState(DEFAULT_SEARCH);
    const [validationError, setValidationError] = React.useState(null);
    const searchItems = () => {
        setValidationError(null);
        setSearchArgs({
            query,
            // @ts-expect-error - TS2322 - Type 'number' is not assignable to type '0 | 1 | 2'.
            active,
        });
    };
    const { getCheckbox, checkedItems } = useCheckboxes({
        externallyCheckedItems: selectedDepartments || [],
        equalsFunc: (a, b) => a.id === b.id,
    });
    const { table, dataState } = usePagedSortedTable({
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            getCheckedItem: (data, index) => data.data[index],
        },
        getData: (sort, page, sArgs) => __awaiter(void 0, void 0, void 0, function* () {
            let isActive;
            switch (sArgs.active) {
                case 0:
                    isActive = false;
                    break;
                case 1:
                    isActive = true;
                    break;
                case 2:
                default:
                    isActive = null;
            }
            return DepartmentService.search({
                query: sArgs.query,
                active: isActive,
            }, {
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
                max: PAGE_SIZE,
                offset: page * PAGE_SIZE,
            });
        }),
        searchArgs,
        getNumPages: (result) => 
        // $FlowFixMe inconsequential error.
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'PagedResult<any>'.
        TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        noDataComponent: "No Departments found",
        initialSort: { sort: "DEPARTMENTNAME", order: "asc" },
        columns: [
            {
                title: "Acronym",
                sortId: "DEPARTMENTACRONYM",
            },
            {
                title: "Name",
                sortId: "DEPARTMENTNAME",
            },
            { title: "Active", sortId: "DEPARTMENTACTIVE", align: "center" },
        ],
        // @ts-expect-error - TS2322 - Type '({ data }: { data: any; }) => any' is not assignable to type 'Node[][] & ((arg1: unknown) => Node[][])'.
        rows: ({ data }) => data.map((department) => [
            department.acronym,
            department.name,
            _jsx(BooleanDisplay, { val: department.active }, "active"),
        ]),
    });
    return children({
        selectedItems: checkedItems,
        isLoading: dataState.isLoading,
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        totalNumItems: (_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total,
        lookup: (_jsxs(_Fragment, { children: [validationError && _jsx(AlertError, { message: validationError }), _jsxs("div", { className: "mb-3 form-inline", children: [_jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: "programSearch", className: "sr-only", children: "Search" }), _jsx("input", { type: "text", className: "form-control", id: "departmentSearch", placeholder: "Search Name", style: { width: 200 }, value: query, onChange: (event) => {
                                        setQuery(event.target.value);
                                    }, onKeyPress: (e) => {
                                        if (e.key === "Enter") {
                                            searchItems();
                                        }
                                    } })] }), _jsxs("div", { className: "form-group mr-3 mt-2", children: [_jsxs("div", { className: "custom-control custom-radio custom-control-inline", children: [_jsx("input", { className: "custom-control-input", type: "radio", id: "activeTrue", value: "1", checked: active === 1, onChange: () => {
                                                setActive(1);
                                            } }), _jsx("label", { className: "custom-control-label", htmlFor: "activeTrue", children: "Active" })] }), _jsxs("div", { className: "custom-control custom-radio custom-control-inline", children: [_jsx("input", { className: "custom-control-input ", type: "radio", id: "activeFalse", checked: active === 0, onChange: () => {
                                                setActive(0);
                                            } }), _jsx("label", { className: "custom-control-label", htmlFor: "activeFalse", children: "Inactive" })] }), _jsxs("div", { className: "custom-control custom-radio custom-control-inline", children: [_jsx("input", { className: "custom-control-input", type: "radio", id: "activeBoth", checked: active === 2, onChange: () => {
                                                setActive(2);
                                            } }), _jsx("label", { className: "custom-control-label", htmlFor: "activeBoth", children: "Both" })] })] }), _jsx("div", { className: "mt-2", children: _jsx(SearchButton, { isLoading: dataState.isLoading, onClick: () => {
                                    searchItems();
                                } }) })] }), _jsx("hr", {}), table] })),
    });
};
export default DepartmentLookup;
